export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig(event);
    const PROJECT_BASE = config.public.PROJECT_BASE;

    return {
        provide: {
            localStorage: {
                getItem(item) {
                    if (process.client) {
                        return localStorage.getItem(item + PROJECT_BASE);
                    } else {
                        return undefined;
                    }
                },

                setItem(item, value) {
                    if (process.client) {
                        return localStorage.setItem(item + PROJECT_BASE, value);
                    }
                },

                removeItem(item) {
                    if (process.client) {
                        return localStorage.removeItem(item + PROJECT_BASE);
                    }
                }
            }
        }
    };
});
